var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.438,
    height: 37.492,
    viewBox: "0 0 37.438 37.492",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone-call-svgrepo-com",
    transform: "translate(-0.344 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3450",
    "data-name": "Group 3450",
    transform: "translate(0.344 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M29.948,48.463a3.688,3.688,0,0,0-2.675-1.227,3.813,3.813,0,0,0-2.706,1.219l-2.5,2.493c-.206-.111-.411-.214-.609-.317-.285-.142-.554-.277-.783-.419a27.177,27.177,0,0,1-6.512-5.935,16.034,16.034,0,0,1-2.137-3.371c.649-.593,1.25-1.211,1.836-1.8.222-.222.443-.451.665-.673a3.63,3.63,0,0,0,0-5.476l-2.16-2.16c-.245-.245-.5-.5-.736-.752-.475-.491-.973-1-1.488-1.472a3.746,3.746,0,0,0-2.651-1.163A3.876,3.876,0,0,0,4.8,28.569l-.016.016L2.094,31.3a5.789,5.789,0,0,0-1.717,3.68A13.872,13.872,0,0,0,1.39,40.85a34.071,34.071,0,0,0,6.053,10.1,37.238,37.238,0,0,0,12.4,9.709,19.319,19.319,0,0,0,6.963,2.057c.166.008.34.016.5.016a5.963,5.963,0,0,0,4.566-1.962c.008-.016.024-.024.032-.04A17.988,17.988,0,0,1,33.287,59.3c.34-.324.688-.665,1.029-1.021a3.947,3.947,0,0,0,1.195-2.738,3.8,3.8,0,0,0-1.219-2.714Zm2.833,8.332c-.008,0-.008.008,0,0-.309.332-.625.633-.965.965a20.808,20.808,0,0,0-1.527,1.583A3.815,3.815,0,0,1,27.313,60.6c-.119,0-.245,0-.364-.008a17.162,17.162,0,0,1-6.172-1.852A35.15,35.15,0,0,1,9.1,49.594a32.125,32.125,0,0,1-5.7-9.488,11.3,11.3,0,0,1-.886-4.954A3.632,3.632,0,0,1,3.606,32.8l2.7-2.7a1.8,1.8,0,0,1,1.2-.562,1.693,1.693,0,0,1,1.155.554l.024.024c.483.451.942.918,1.424,1.416.245.253.5.506.752.768l2.16,2.16a1.51,1.51,0,0,1,0,2.453c-.229.229-.451.459-.681.681-.665.681-1.3,1.314-1.986,1.931-.016.016-.032.024-.04.04a1.614,1.614,0,0,0-.411,1.8l.024.071a17.343,17.343,0,0,0,2.556,4.17l.008.008a29.043,29.043,0,0,0,7.027,6.394,10.8,10.8,0,0,0,.973.53c.285.142.554.277.783.419.032.016.063.04.095.055a1.715,1.715,0,0,0,.783.2,1.692,1.692,0,0,0,1.2-.546l2.706-2.706a1.79,1.79,0,0,1,1.195-.593,1.612,1.612,0,0,1,1.139.578l.016.016,4.36,4.36A1.565,1.565,0,0,1,32.781,56.795Z",
    transform: "translate(-0.344 -25.237)",
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    d: "M245.823,88.044a10.184,10.184,0,0,1,8.293,8.293,1.062,1.062,0,0,0,1.052.886,1.411,1.411,0,0,0,.182-.016,1.069,1.069,0,0,0,.878-1.234A12.314,12.314,0,0,0,246.195,85.94a1.074,1.074,0,0,0-1.234.87A1.057,1.057,0,0,0,245.823,88.044Z",
    transform: "translate(-225.589 -79.126)",
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M266.539,16.539A20.277,20.277,0,0,0,250.016.016a1.067,1.067,0,1,0-.348,2.1,18.111,18.111,0,0,1,14.766,14.766,1.062,1.062,0,0,0,1.052.886,1.412,1.412,0,0,0,.182-.016A1.048,1.048,0,0,0,266.539,16.539Z",
    transform: "translate(-229.117 0)",
    fill: "#181818"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCallIcon);
export default __webpack_public_path__ + "static/media/phone-call-icon.daeaa89801aa02fb5d721b7980fc6efd.svg";
export { ForwardRef as ReactComponent };